// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function FooterMenuMobile(Props) {
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const country = Buhta_landing__Route.getCountry(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  const intl = ReactIntl.useIntl();
  const match$1 = Buhta_landing__Content.Context.useContent(undefined);
  const menus = match$1[0].mainMenus;
  const dropdownItems = Belt__Belt_List.keep(menus, (function (i) {
    return i.type_ === "dropdown";
  }));
  const allItems = Stdlib__List.append(dropdownItems, {
    hd: {
      type_: "dropdown",
      name: Buhta_landing__I18n.trans(intl, "help"),
      menu_items: {
        hd: {
          title: Buhta_landing__I18n.trans(intl, "help_center"),
          subtitle: "",
          path: "",
          icon: "",
          order: 0
        },
        tl: {
          hd: {
            title: Buhta_landing__I18n.trans(intl, "how_to_work_with_buhta"),
            subtitle: "",
            path: "",
            icon: "",
            order: 0
          },
          tl: {
            hd: {
              title: Buhta_landing__I18n.trans(intl, "contacts"),
              subtitle: "",
              path: "/contact",
              icon: "",
              order: 0
            },
            tl: /* [] */ 0
          }
        }
      },
      link: undefined,
      country: countryStr,
      order: 0
    },
    tl: {
      hd: {
        type_: "dropdown",
        name: Buhta_landing__I18n.trans(intl, "company"),
        menu_items: {
          hd: {
            title: Buhta_landing__I18n.trans(intl, "about"),
            subtitle: "",
            path: "/about",
            icon: "",
            order: 0
          },
          tl: {
            hd: {
              title: Buhta_landing__I18n.trans(intl, "partners"),
              subtitle: "",
              path: "/partners",
              icon: "",
              order: 0
            },
            tl: {
              hd: {
                title: Buhta_landing__I18n.trans(intl, "pricing"),
                subtitle: "",
                path: "/pricing",
                icon: "",
                order: 0
              },
              tl: {
                hd: {
                  title: Buhta_landing__I18n.trans(intl, "contacts"),
                  subtitle: "",
                  path: "/contact",
                  icon: "",
                  order: 0
                },
                tl: {
                  hd: {
                    title: Buhta_landing__I18n.trans(intl, "company_details"),
                    subtitle: "",
                    path: "/company-details",
                    icon: "",
                    order: 0
                  },
                  tl: {
                    hd: {
                      title: Buhta_landing__I18n.trans(intl, "jobs"),
                      subtitle: "",
                      path: "/jobs",
                      icon: "",
                      order: 0
                    },
                    tl: {
                      hd: {
                        title: Buhta_landing__I18n.trans(intl, "awards"),
                        subtitle: "",
                        path: "/awards",
                        icon: "",
                        order: 0
                      },
                      tl: {
                        hd: {
                          title: Buhta_landing__I18n.trans(intl, "licenses"),
                          subtitle: "",
                          path: "/licenses",
                          icon: "",
                          order: 0
                        },
                        tl: {
                          hd: {
                            title: Buhta_landing__I18n.trans(intl, "legal_security"),
                            subtitle: "",
                            path: "/legal/security",
                            icon: "",
                            order: 0
                          },
                          tl: /* [] */ 0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        link: undefined,
        country: countryStr,
        order: 0
      },
      tl: /* [] */ 0
    }
  });
  const activeItem = Stdlib__List.nth(allItems, idx);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, item) {
          const Key = "footer_menu_" + String(index);
          return JsxRuntime.jsx("p", {
            children: item.name,
            className: Cn.fromList({
              hd: "label-medium mt-2 cursor-pointer",
              tl: {
                hd: idx === index ? "text-black-landing" : "text-gray-landing",
                tl: /* [] */ 0
              }
            }),
            onClick: (function (param) {
              Curry._1(setIdx, (function (param) {
                return index;
              }));
            })
          }, Key);
        }), allItems)),
        className: "flex-wrap pt-6 flex justify-between"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("ul", {
            children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, item) {
              const url = "/" + countryStr + "/" + languageStr + item.path;
              const Key = "dropdown_" + String(index);
              return JsxRuntime.jsxs("li", {
                children: [
                  JsxRuntime.jsx(Buhta_landing__Link.make, {
                    route: Buhta_landing__Route.ofUrl(Buhta_landing__Route.getRouterUrl(url)),
                    className: "transition-all duration-200 ease-in-out hover:text-gray-light-landing",
                    children: item.title
                  }),
                  item.path === "/" ? JsxRuntime.jsx("img", {
                      className: "inline ml-2",
                      src: StaticAsset.src("/static/icons/soon.svg")
                    }) : null
                ],
                className: "mt-2"
              }, Key);
            }), activeItem.menu_items)),
            className: "paragraph-small text-gray-landing mt-8"
          }),
          activeItem.name === Buhta_landing__I18n.trans(intl, "company") ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    alt: "instagram",
                    src: StaticAsset.src("/static/icons/instagram.svg")
                  }),
                  href: "https://www.instagram.com/buhta.kz/",
                  target: "__blank"
                }),
                JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    alt: "linkedin",
                    src: StaticAsset.src("/static/icons/linkedin.svg")
                  }),
                  href: "https://www.linkedin.com/company/buhta/",
                  target: "__blank"
                }),
                JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    alt: "x",
                    src: StaticAsset.src("/static/icons/x.svg")
                  }),
                  href: "https://twitter.com/Buhta_kz",
                  target: "__blank"
                }),
                JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    alt: "telegram",
                    src: StaticAsset.src("/static/icons/telegram.svg")
                  }),
                  href: "https://t.me/buhta_kz",
                  target: "__blank"
                }),
                JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    alt: "facebook",
                    src: StaticAsset.src("/static/icons/facebook.svg")
                  }),
                  href: "https://www.facebook.com/buhta",
                  target: "__blank"
                })
              ],
              className: "flex mt-5 gap-3"
            }) : null
        ]
      })
    ]
  });
}

const make = FooterMenuMobile;

export {
  make,
}
/* Buhta_landing__Content Not a pure module */
